import Styled from 'styled-components';
import { PageHeader } from 'antd';

const PageHeaderStyle = Styled(PageHeader)`
  &.subscription-page-header{
    @media only screen and (max-width: 575px){
      padding: 14px 16px 10px;
      .ant-page-header-heading{
        display: block;
      }
      .ant-page-header-heading-title{
        display: block;
        margin: 8px 0 0;
        font-size: 26px;
        white-space: normal;
      }
      .ant-breadcrumb{
        display: flex;
        min-width: 0;
        overflow-x: auto;
        white-space: nowrap;
      }
    }
  }

  .page-header-actions button.ant-btn-white svg {
    width: 12px;
    height: 12px;
    ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 2px;
    color: #5f63f2;
  }
  i +span, svg +span, img +span {
      ${({ theme }) => (!theme.rtl ? 'margin-left' : 'margin-right')}: 6px;
  }
`;

export { PageHeaderStyle };
